'use strict';
require('../modules/web.url-search-params');
require('../modules/web.url-search-params.delete');
require('../modules/web.url-search-params.has');
require('../modules/web.url-search-params.size');
var path = require('../internals/path');

module.exports = path.URLSearchParams;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/web/url-search-params.js
// module id = 787
// module chunks = 13